var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44073_25136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9988C0 22.4452 0.440078 24.7887 1.24398 26.9553L20 28.6945L38.756 26.9553C39.5599 24.7887 40 22.4452 40 19.9988C40 17.5524 39.5599 15.209 38.756 13.0424L20 11.3032L1.24398 13.0424C0.440078 15.209 0 17.5524 0 19.9988Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7581 13.043C35.9323 5.42709 28.6014 -0.000488281 20.0021 -0.000488281C11.4028 -0.000488281 4.07195 5.42709 1.24609 13.043H38.7581Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24609 26.9568C4.07195 34.5727 11.4028 40.0003 20.0021 40.0003C28.6014 40.0003 35.9323 34.5727 38.7581 26.9568H1.24609Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44073_25136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.ae04e08643850f636e2c85ed2b5c8dec.svg";
export { ForwardRef as ReactComponent };